/**
 * OrbDocGettingStartedIntroductionENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocGettingStartedIntroductionENDocScreen
 */

import { useOrbDocGettingStartedIntroductionENDocScreenLogic } from '@/hooks/traits/useOrbDocGettingStartedIntroductionENDocScreenLogic';
import type { OrbDocGettingStartedIntroductionENDocScreenConfig } from '@/hooks/traits/useOrbDocGettingStartedIntroductionENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocGettingStartedIntroductionENDocView as OrbDocGettingStartedIntroductionENDocViewEntity } from '@app/shared';
import { OrbDocGettingStartedIntroductionENDocBodyView } from '@/components/traits/OrbDocGettingStartedIntroductionENDocBodyView';
import { OrbDocGettingStartedIntroductionENDocFooterView } from '@/components/traits/OrbDocGettingStartedIntroductionENDocFooterView';
import { OrbDocGettingStartedIntroductionENDocHeaderView } from '@/components/traits/OrbDocGettingStartedIntroductionENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocGettingStartedIntroductionENDocScreenViewProps {
  config?: Partial<OrbDocGettingStartedIntroductionENDocScreenConfig>;
}

export function OrbDocGettingStartedIntroductionENDocScreenView({ config: propsConfig }: OrbDocGettingStartedIntroductionENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocGettingStartedIntroductionENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocGettingStartedIntroductionENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocGettingStartedIntroductionEN" trait="OrbDocGettingStartedIntroductionENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocGettingStartedIntroductionENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocGettingStartedIntroductionENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocGettingStartedIntroductionENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocGettingStartedIntroductionENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocGettingStartedIntroductionENDocScreenView;
